import { useState } from "react";
import { employeeTestimonialsData } from "@/mocks/homeData";

export default function EmployeeTestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const testimonial = employeeTestimonialsData.testimonials[activeIndex];

  return (
    <section id="employee-testimonials" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            Team Stories
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {employeeTestimonialsData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {employeeTestimonialsData.subheadline}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8">
            <div className="lg:col-span-2 flex flex-col justify-center">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading font-bold text-xl md:text-2xl text-primary-600">
                    {testimonial.author
                      .split(" ")
                      .map((n) => n[0])
                      .join("")}
                  </span>
                </div>
                <div>
                  <div className="font-heading font-semibold text-foreground-950 text-base md:text-lg">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-foreground-600">
                    {testimonial.role}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">
                    {testimonial.years}
                  </div>
                </div>
              </div>
              <div className="flex gap-2">
                {employeeTestimonialsData.testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveIndex(idx)}
                    className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                      idx === activeIndex
                        ? "bg-primary-500 w-6"
                        : "bg-background-300 hover:bg-background-400"
                    }`}
                    aria-label={`Go to testimonial ${idx + 1}`}
                  />
                ))}
              </div>
            </div>

            <div className="lg:col-span-3 bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className="ri-star-fill text-accent-500 text-base"
                  />
                ))}
              </div>
              <blockquote className="text-foreground-700 leading-relaxed text-base md:text-lg mb-5">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>
              <div className="pt-4 border-t border-background-200/70">
                <span className="text-xs text-foreground-500 uppercase tracking-wider font-semibold">
                  Placed At
                </span>
                <p className="text-sm text-foreground-700 mt-1">
                  {testimonial.placedAt}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}